
export function getOrdinal(d){
	if (d > 3 && d < 21) return "th"; 
	switch (d % 10) {
	case 1:  return "st";
	case 2:  return "nd";
	case 3:  return "rd";
	default: return "th";
	}
}

export function getNextMonth(d){
	const daysInNextMonth = getDaysInNextMonth(d);
	return new Date(d.getFullYear(), d.getMonth() +1, Math.min(daysInNextMonth,d.getDate()));
}

export function getPreviousMonth(d){
	const daysInPrevMonth = getDaysInPrevMonth(d);
	return new Date(d.getFullYear(), d.getMonth() -1, Math.min(daysInPrevMonth,d.getDate()));
}

export function getDaysInMonth(d){
	return new Date(d.getFullYear(), d.getMonth()+1, 0).getDate();
}

export function getDaysInNextMonth(d){
	return new Date(d.getFullYear(), d.getMonth()+2, 0).getDate();
}

export function getDaysInPrevMonth(d){
	return new Date(d.getFullYear(), d.getMonth(), 0).getDate();
}

export function getMonthPadding(d){
	return new Date(d.getFullYear(), d.getMonth(), 1).getDay();
}

export function daysBetween(dt1, dt2){
	return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) ) /(1000 * 60 * 60 * 24));
}

export function zeroPadNumber(number, length) {
	var str = "" + number;
	while (str.length < length) {
		str = "0" + str;
	}
	return str;
}

export function isChild(obj,parentObj){
	while (obj != undefined && obj != null && obj.tagName.toUpperCase() != "BODY"){
		if (obj == parentObj){
			return true;
		}
		obj = obj.parentNode;
	}
	return false;
}

export const focusableElementsQuery = "button, [href], input, select, textarea, [tabindex]:not([tabindex=\"-1\"])";

export function getFocusableElements(el) { return el.querySelectorAll(focusableElementsQuery); }

export function focusLock(event, parent){
	//the event should be a blur event. check if the relatedTarget is inside or
	//outside our parent to decide what to do. This should only be called if the 
	//view/widget is active.
	const newFocusEl = event.relatedTarget;
	const prevFocusEl = event.target;
	const focusable = getFocusableElements(parent);
	const firstFocusable = focusable[0];
	const lastFocusable = focusable[focusable.length - 1];

	if(!isChild(newFocusEl,parent)){ //if the newly focused element isn't a child
		switch(prevFocusEl){
		case firstFocusable:
			lastFocusable.focus();
			break;
		case lastFocusable:
			firstFocusable.focus();
			break;
		}
	}
}